import { usePostRedirectUrl } from 'builder/features/futureLearn/hooks/useGetRedirectUrl'

type UpskillActions = {
  handleClickCourse: (cmsgid: string) => Promise<void>
  handleExploreCourses: () => void
}

export const useUpskillActions = (): UpskillActions => {
  const { mutateAsync } = usePostRedirectUrl()

  const redirectToFutureLearn = async (cmsgid?: string) => {
    const response = await mutateAsync({ cmsgid })
    window.open(response.redirect_url, '_blank')
  }

  const handleClickCourse = async (cmsgid: string) => {
    await redirectToFutureLearn(cmsgid)
  }

  const handleExploreCourses = async () => {
    await redirectToFutureLearn()
  }

  return { handleClickCourse, handleExploreCourses }
}
